import { Bug, ShieldCheck, BedDouble, Rat, Droplets, SprayCan, Building2, Home, PhoneCall, ArrowRight } from 'lucide-react';

const services = [
    {
        icon: <Bug size={28} />,
        title: "COCKROACH CONTROL",
        desc: "Gel Application and Odorless Spray. Totally proven, odorless and non messy treatment.",
        path: "/all-services#cockroach-control"
    },
    {
        icon: <ShieldCheck size={28} />,
        title: "TERMITE CONTROL",
        desc: "Drill-Fill-Seal Method. Comprehensive termite protection for your valuable wood works.",
        path: "/all-services#termite-control"
    },
    {
        icon: <BedDouble size={28} />,
        title: "BED BUG CONTROL",
        desc: "Odorless Spray Treatment that prevents Bed Bug bites and ensures a peaceful night sleep.",
        path: "/all-services#bed-bug-control"
    },
    {
        icon: <Rat size={28} />,
        title: "RODENT CONTROL",
        desc: "IPM approach: inspection, sanitation, rodent proofing, trapping and rodenticides.",
        path: "/all-services#rodent-control"
    },
    {
        icon: <Droplets size={28} />,
        title: "MOSQUITO CONTROL",
        desc: "Larvicide Treatment, Indoor Residual Spray (IRS) and Fogging.",
        path: "/all-services#mosquito-control"
    },
    {
        icon: <SprayCan size={28} />,
        title: "GENERAL PEST CONTROL",
        desc: "General pest management for residential and commercial premises.",
        path: "/all-services#general-pest-control"
    },
    {
        icon: <Building2 size={28} />,
        title: "COMMERCIAL PEST CONTROL",
        desc: "Pest control for commercial premises.",
        path: "/all-services#commercial-pest-control"
    },
    {
        icon: <Home size={28} />,
        title: "RESIDENTIAL PEST CONTROL",
        desc: "Pest control for residential premises.",
        path: "/all-services#residential-pest-control"
    }
];



const HomeServices = () => {
    return (
        <section className="hob-services-section">
            <div className="hob-services-header">
                <h2 className="hob-services-heading">Our  Services</h2>
                <p className="hob-services-subtext">Professional, eco-friendly and cost-effective pest control for homes and businesses across Mumbai.</p>
            </div>
            <div className="hob-services-grid">
                {services.map((service, idx) => (
                    <div className="hob-service-card" key={idx}>
                        <div className="hob-service-icon">{service.icon}</div>
                        <h3 className="hob-service-title">{service.title}</h3>
                        <p className="hob-service-desc">{service.desc}</p>
                        <div className="hob-service-actions">
                            <span
                                className="hob-service-link"
                                onClick={() => window.location.href = service.path}
                                style={{ cursor: "pointer" }}
                            >
                                Learn More <ArrowRight size={14} />
                            </span>
                            <span
                                className="hob-service-link"
                               onClick={() => (window.location.href = "tel:8530352444")}
                                style={{ cursor: "pointer" }}
                            >
                               <PhoneCall size={14} />Call Now
                            </span>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default HomeServices;
